
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("faVFI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $7yOcR = parcelRequire("7yOcR");


var $b4wUN = parcelRequire("b4wUN");


var $eXmBZ = parcelRequire("eXmBZ");

const $0c4d6050022a8715$export$1173a795b68d5ee4 = ({ iconString: iconString, iconColor: iconColor, profilePicture: profilePicture })=>{
    let IconComponent;
    switch(iconString){
        case 'feedback':
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($7yOcR)));
            break;
        case 'mention':
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($b4wUN)));
            break;
        case 'avatar':
            return profilePicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                src: profilePicture,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b4wUN))), {
                color: "var(--ds-icon, #292A2E)",
                label: ""
            });
        case 'info':
        default:
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ)));
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconComponent, {
        color: iconColor,
        label: ""
    });
};
const $0c4d6050022a8715$export$15b497b4bcae19f4 = (iconString, iconColor, profilePicture)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c4d6050022a8715$export$1173a795b68d5ee4, {
        iconString: iconString,
        iconColor: iconColor ?? "var(--ds-icon, #292A2E)",
        profilePicture: profilePicture
    });


function $e69c7ecf0858446f$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $e69c7ecf0858446f$var$id = 0;
function $e69c7ecf0858446f$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $e69c7ecf0858446f$var$id++ + "_" + e;
}
var $e69c7ecf0858446f$var$_flags = /*#__PURE__*/ $e69c7ecf0858446f$var$_classPrivateFieldLooseKey("flags");
class $e69c7ecf0858446f$export$a3823aa64e973105 {
    showFlag(flagProps) {
        $e69c7ecf0858446f$var$_classPrivateFieldLooseBase(this, $e69c7ecf0858446f$var$_flags)[$e69c7ecf0858446f$var$_flags].showFlag({
            ...flagProps,
            customIcon: flagProps.type === 'custom' ? (0, $0c4d6050022a8715$export$15b497b4bcae19f4)(flagProps.iconString, flagProps.iconColor, flagProps.profilePicture) : undefined
        });
    }
    hideFlag(flagId) {
        $e69c7ecf0858446f$var$_classPrivateFieldLooseBase(this, $e69c7ecf0858446f$var$_flags)[$e69c7ecf0858446f$var$_flags].hideFlag(flagId);
    }
    constructor(flags){
        Object.defineProperty(this, $e69c7ecf0858446f$var$_flags, {
            writable: true,
            value: void 0
        });
        $e69c7ecf0858446f$var$_classPrivateFieldLooseBase(this, $e69c7ecf0858446f$var$_flags)[$e69c7ecf0858446f$var$_flags] = flags;
    }
}
module.exports["ContentTypesFlagService"] = $e69c7ecf0858446f$export$a3823aa64e973105;

});

parcelRegister("4RbZ3", function(module, exports) {
const $ebcb8f414be8c1a8$var$ProductKeys = [
    'whiteboards',
    'databases',
    'confluence'
];
class $ebcb8f414be8c1a8$export$f3bbb07f64a9b14d {
    dispose() {
        // Using clear here instead of re-assignment to a new map to save memory.
        this.eventHandlers.clear();
        this.eventHandlersByProduct.clear();
    }
    /**
   * This is called in Whiteboards to register the any event callbacks.
   * Confluence FE can then use any of these events to trigger the whiteboard events.
   */ registerEventHandler(event, handler) {
        this.eventHandlers.set(event, handler);
    }
    /**
   * Setup function to be called by a product to register event callbacks. When you use this, you can
   * listen to certain events from other products and NOTIFY other products about certain events
   */ mountEventService(source) {
        /**
     * Expected usage in downstream product:
     * const eventService = contentTypesEventService.mountEventService('whiteboards');
     * eventService.registerHandler('copy', (message) => {
     *   // Handle the copy event
     *   console.log('Whiteboards has been notified about a copy', message);
     * });
     *
     * Invoking a command from another product (e.g., Confluence):
     * const confluenceEventService = contentTypesEventService.mountEventService('confluence');
     * confluenceEventService.sendCommand({
     *  type: 'copy',
     * });
     */ return {
            /**
       * Called by whatever product to mount a listener that will only trigger when OTHER products
       * invoke a command that matches the ContentTypeCommandType.
       */ registerHandler: (event, handler)=>{
                this.eventHandlersByProduct.get(source)?.set(event, handler);
            },
            /**
       * Called by whatever product to unregister a listener that was previously registered
       */ unregisterHandler: (event)=>{
                this.eventHandlersByProduct.get(source)?.delete(event);
            },
            /**
       * Check if an event has any handlers registered to it
       * @param event
       */ hasEventHandler: (event)=>{
                return this.eventHandlersByProduct.get(source)?.has(event);
            },
            /**
       * Trigger an event that OTHER products will receive
       */ sendCommand: (message)=>{
                if (!message || !message.type) return;
                // Call all other sources and notify them that we have triggered an event
                $ebcb8f414be8c1a8$var$ProductKeys.forEach((productKey)=>{
                    // Exclude self. NO SELF TRIGGERING!
                    if (productKey === source) return;
                    this.eventHandlersByProduct.get(productKey)?.get(message.type)?.({
                        ...message.payload,
                        source: source // Source gets injected automatically after we have mounted it once.
                    });
                });
            }
        };
    }
    /**
   * This is called in Whiteboards to unregister the any event callbacks.
   */ unregisterEventHandler(event) {
        this.eventHandlers.delete(event);
    }
    /**
   * Check if an event has any handlers registered to it
   * @param event
   */ hasEventHandler(event) {
        return this.eventHandlers.has(event);
    }
    /**
   * Trigger an event in Whiteboards.
   */ triggerEvent(event) {
        this.eventHandlers.get(event)?.();
    }
    constructor(){
        this.eventHandlers = void 0;
        // Will eventually completely replace V1 event handlers
        this.eventHandlersByProduct = void 0;
        this.eventHandlers = new Map();
        this.eventHandlersByProduct = new Map();
        this.eventHandlersByProduct.set('whiteboards', new Map());
        this.eventHandlersByProduct.set('databases', new Map());
        this.eventHandlersByProduct.set('confluence', new Map());
    }
}
module.exports["ContentTypeEventService"] = $ebcb8f414be8c1a8$export$f3bbb07f64a9b14d;

});

parcelRegister("hgdkS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $kevJM = parcelRequire("kevJM");


var $7hXDW = parcelRequire("7hXDW");


var $hmuev = parcelRequire("hmuev");


var $kmWRd = parcelRequire("kmWRd");

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");









const $50364c7681d2ff9d$var$footerBaseStyles = (0, $ecnYn.xcss)({
    borderTopColor: 'color.border',
    borderTopStyle: 'solid',
    borderTopWidth: 'border.width'
});
const $50364c7681d2ff9d$export$87589ca4d6050188 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            paddingBlock: "space.200",
            paddingInline: "space.300",
            xcss: $50364c7681d2ff9d$var$footerBaseStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.200",
        paddingInline: "space.300",
        xcss: $50364c7681d2ff9d$var$footerBaseStyles
    }, children);
};



var $ai7NK = parcelRequire("ai7NK");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $aCrkK = parcelRequire("aCrkK");


var $9wGTI = parcelRequire("9wGTI");

/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");

const $f24fd770e6b9a487$export$c17d09885b37d368 = ({ contentType: contentType, contentId: contentId })=>{
    const { data: data, loading: loading, error: error, fetchMore: fetchMore, refetch: refetch } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useVersionHistoryContentVersionHistoryQuery($contentId:ID!$filter:ContentVersionHistoryFilter!$after:String){contentVersionHistory(id:$contentId after:$after first:30 filter:$filter){nodes{author{id isActive displayName}contentId number updatedTime contentProperties{latest{externalVersionId versionContainsAIContent}}}pageInfo{hasNextPage hasPreviousPage startCursor endCursor}}}`, {
        variables: {
            contentId: contentId,
            filter: {
                contentType: contentType
            }
        }
    });
    const startCursor = data?.contentVersionHistory?.pageInfo?.startCursor || null;
    const hasNextPage = data?.contentVersionHistory?.pageInfo?.hasNextPage || false;
    const autosavedVersions = data?.contentVersionHistory?.nodes || [];
    const loadMoreVersions = ()=>{
        if (hasNextPage && startCursor && !loading) fetchMore({
            variables: {
                contentId: contentId,
                filter: {
                    contentType: contentType
                },
                after: startCursor
            },
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                if (!fetchMoreResult?.contentVersionHistory) return prev;
                const prevNodes = prev?.contentVersionHistory?.nodes || [];
                const fetchedNodes = fetchMoreResult.contentVersionHistory.nodes || [];
                const pageInfo = fetchMoreResult.contentVersionHistory.pageInfo || prev?.contentVersionHistory?.pageInfo;
                return {
                    contentVersionHistory: {
                        nodes: [
                            ...prevNodes,
                            ...fetchedNodes
                        ],
                        pageInfo: pageInfo,
                        __typename: 'ContentVersionHistoryConnection'
                    }
                };
            }
        });
    };
    return {
        autosavedVersions: autosavedVersions,
        loading: loading,
        error: error,
        loadMoreVersions: loadMoreVersions,
        cursor: startCursor,
        hasNextPage: hasNextPage,
        refetch: refetch
    };
};






var $inPa6 = parcelRequire("inPa6");


var $ep3mz = parcelRequire("ep3mz");

const $bac38a4aff776821$export$8fea35734ad69528 = ()=>{
    const [{ contentType: contentType, contentId: contentId }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onVersionClick = (0, $42omo.useCallback)((version)=>{
        if (version) {
            const { updatedTime: updatedTime, number: number } = version;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'version',
                    actionSubjectId: 'selected',
                    source: 'versionHistoryScreen',
                    objectId: contentId,
                    objectType: contentType,
                    attributes: {
                        updatedTime: updatedTime,
                        number: number
                    }
                }
            }).fire();
        } else createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'version',
                actionSubjectId: 'current',
                source: 'versionHistoryScreen',
                objectId: contentId,
                objectType: contentType
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const onVersionHistoryMenuOpen = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'versionHistoryScreen',
                attributes: {
                    objectType: contentType,
                    objectId: contentId
                }
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const onCopyVersionContent = (0, $42omo.useCallback)((version)=>{
        const { updatedTime: updatedTime, number: number } = version;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'copyVersionContent',
                source: 'versionHistoryScreen',
                objectId: contentId,
                objectType: contentType,
                attributes: {
                    updatedTime: updatedTime,
                    number: number
                }
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const onRestore = (0, $42omo.useCallback)((version)=>{
        const { updatedTime: updatedTime, number: number } = version;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'restore',
                objectId: contentId,
                objectType: contentType,
                source: 'versionHistoryModal',
                attributes: {
                    updatedTime: updatedTime,
                    number: number
                }
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const onRestoreModalClose = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'closeButton',
                source: 'versionHistoryScreen',
                objectId: contentId,
                objectType: contentType
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    return {
        onVersionClick: onVersionClick,
        onVersionHistoryMenuOpen: onVersionHistoryMenuOpen,
        onCopyVersionContent: onCopyVersionContent,
        onRestore: onRestore,
        onRestoreModalClose: onRestoreModalClose
    };
};


/**
 * @graphql cc
 */ 













var $diswb = parcelRequire("diswb");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");







var $5dK2X = parcelRequire("5dK2X");







var $aoVih = parcelRequire("aoVih");


var $50sHn = parcelRequire("50sHn");





var $dPJCf = parcelRequire("dPJCf");


var $caYQd = parcelRequire("caYQd");


var $lqy4C = parcelRequire("lqy4C");





var $b3j2Y = parcelRequire("b3j2Y");








var $ck0S9 = parcelRequire("ck0S9");













var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");

var $jVhgp = parcelRequire("jVhgp");







var $4noo5 = parcelRequire("4noo5");

const $bd5348f98ee50a88$var$MAX_TITLE_NAME_LENGTH = 60;
const $bd5348f98ee50a88$var$i18n = (0, $cgtv4.defineMessages)({
    whiteboardTitle: {
        id: "version-history.whiteboard-title",
        defaultMessage: "Whiteboard title"
    },
    titleLengthError: {
        id: "version-history.title.length.error",
        defaultMessage: "{maxLength, plural, one {Title has a maximum of {maxLength} character} other {Title has a maximum of {maxLength} characters}}"
    },
    databaseTitle: {
        id: "version-history.database-title",
        defaultMessage: "Database title"
    }
});
const $bd5348f98ee50a88$var$titleUpdateMessaging = {
    whiteboard: $bd5348f98ee50a88$var$i18n.whiteboardTitle,
    database: $bd5348f98ee50a88$var$i18n.databaseTitle
};
const $bd5348f98ee50a88$var$labelComponentStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.100',
    color: 'color.text.subtlest'
});
const $bd5348f98ee50a88$var$LabelComponent = ({ contentType: contentType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $bd5348f98ee50a88$var$labelComponentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $bd5348f98ee50a88$var$titleUpdateMessaging[contentType]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVhgp.default), null));
const $bd5348f98ee50a88$export$68f60d0fda17fe94 = ({ title: title, setTitle: setTitle, contentType: contentType })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const handleTitleChange = (e)=>{
        const value = e.target.value;
        if (value.length <= $bd5348f98ee50a88$var$MAX_TITLE_NAME_LENGTH) {
            setTitle(value);
            setHasError(false);
        } else setHasError(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bd5348f98ee50a88$var$LabelComponent, {
            contentType: contentType
        }),
        name: "version-title"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            ...fieldProps,
            value: title,
            onChange: handleTitleChange,
            maxLength: $bd5348f98ee50a88$var$MAX_TITLE_NAME_LENGTH + 1,
            autoComplete: "off",
            isInvalid: hasError,
            testId: "version-title-input"
        })), hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ErrorMessage), null, formatMessage($bd5348f98ee50a88$var$i18n.titleLengthError, {
        maxLength: $bd5348f98ee50a88$var$MAX_TITLE_NAME_LENGTH
    })));
};


const $3e7e8a0093eea0b3$var$i18n = (0, $cgtv4.defineMessages)({
    restoreContentTitle: {
        id: "version-history.restore.content.title",
        defaultMessage: "Restore"
    },
    restoreButton: {
        id: "version-history.restore.button",
        defaultMessage: "Restore"
    },
    whiteboardInfoBoxText: {
        id: "version-history.info.box.text",
        defaultMessage: "When restoring a board, permission and share settings remain the same."
    },
    saveWorkWithoutCreatingText: {
        id: "version-history.save-work-without-creating.text",
        defaultMessage: "To save work without creating, try copying content from the whiteboard to an editable whiteboard."
    },
    spaceSelectorLabel: {
        id: "version-history.space-selector.label",
        defaultMessage: "Select space"
    },
    whiteboardPlaceholderTitle: {
        id: "version-history.placeholder.whiteboard.title",
        defaultMessage: "[Restored] Untitled board {date}"
    },
    duplicateTitleErrorTitle: {
        id: "version-history.restore-modal.conflicting-title-error-title",
        defaultMessage: "Duplicate title in this space"
    },
    duplicateTitleErrorBody: {
        id: "version-history.restore-modal.conflicting-title-error-body",
        defaultMessage: "To restore your board, create a unique title or try adding it to a different space."
    },
    newDuplicateTitleErrorBody: {
        id: "version-history.restore-modal.new-conflicting-title-error-body",
        defaultMessage: "To continue restoring, create a unique title or try adding it to a different space."
    },
    spacePermissionErrorTitle: {
        id: "version-history.restore-modal.space-permission-error-title",
        defaultMessage: "You don\u2019t have space access"
    },
    spacePermissionErrorBody: {
        id: "version-history.restore-modal.space-permission-error-body",
        defaultMessage: "To restore this board, you\u2019ll need permissions to <b>Create</b> in this space."
    },
    newSpacePermissionErrorBody: {
        id: "version-history.restore-modal.new-space-permission-error-body",
        defaultMessage: "To restore this content, you\u2019ll need permissions to <b>Create</b> in this space."
    },
    genericErrorTitle: {
        id: "version-history.restore-modal.generic-error-title",
        defaultMessage: "We couldn\u2019t complete your request"
    },
    genericErrorBody: {
        id: "version-history.restore-modal.generic-error-body",
        defaultMessage: "Try refreshing the page, or check your network connection."
    },
    databasePlaceholderTitle: {
        id: "version-history.placeholder.database.title",
        defaultMessage: "[Restored] Untitled database {date}"
    },
    databaseInfoBoxText: {
        id: "version-history.database.info.box.text",
        defaultMessage: "When restoring a database, permission and share settings remain the same."
    }
});
const $3e7e8a0093eea0b3$var$restoreContentModalMessaging = {
    whiteboard: {
        description: $3e7e8a0093eea0b3$var$i18n.whiteboardInfoBoxText,
        placeholderTitle: $3e7e8a0093eea0b3$var$i18n.whiteboardPlaceholderTitle
    },
    database: {
        description: $3e7e8a0093eea0b3$var$i18n.databaseInfoBoxText,
        placeholderTitle: $3e7e8a0093eea0b3$var$i18n.databasePlaceholderTitle
    }
};
const $3e7e8a0093eea0b3$var$EXPECTED_ERROR_MESSAGE = {
    duplicateTitle: 'exists with the same title in this space',
    spacePermissions: '.PermissionException: Could not create content'
};
const $3e7e8a0093eea0b3$var$errorSectionMessageStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
const $3e7e8a0093eea0b3$var$ErrorSectionMessage = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let errorTitle;
    let errorBody;
    if (!error) return null;
    if (error.message.includes($3e7e8a0093eea0b3$var$EXPECTED_ERROR_MESSAGE.duplicateTitle)) {
        errorTitle = $3e7e8a0093eea0b3$var$i18n.duplicateTitleErrorTitle;
        errorBody = (0, $9wGTI.fg)('confluence_frontend_databases_version_history_ui') ? $3e7e8a0093eea0b3$var$i18n.newDuplicateTitleErrorBody : $3e7e8a0093eea0b3$var$i18n.duplicateTitleErrorBody;
    } else if (error.message.includes($3e7e8a0093eea0b3$var$EXPECTED_ERROR_MESSAGE.spacePermissions)) {
        errorTitle = $3e7e8a0093eea0b3$var$i18n.spacePermissionErrorTitle;
        errorBody = (0, $9wGTI.fg)('confluence_frontend_databases_version_history_ui') ? $3e7e8a0093eea0b3$var$i18n.newSpacePermissionErrorBody : $3e7e8a0093eea0b3$var$i18n.spacePermissionErrorBody;
    } else {
        errorTitle = $3e7e8a0093eea0b3$var$i18n.genericErrorTitle;
        errorBody = $3e7e8a0093eea0b3$var$i18n.genericErrorBody;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3e7e8a0093eea0b3$var$errorSectionMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "error",
        title: formatMessage(errorTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...errorBody,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
        }
    }))));
};
const $3e7e8a0093eea0b3$export$63ec0fdbb660e929 = ({ onClose: onClose, selectedVersion: selectedVersion, contentType: contentType })=>{
    const { formatMessage: formatMessage, formatDate: formatDate, formatTime: formatTime } = (0, $8C5kA.default)();
    const { onRestore: onRestore } = (0, $bac38a4aff776821$export$8fea35734ad69528)();
    const selectedVersionDate = (0, $ck0S9.getFormattedDate)(selectedVersion.updatedTime, formatDate, formatTime);
    // use current space as default space key
    const [{ spaceKey: spaceKey, contentId: contentId }] = (0, $ep3mz.usePageState)();
    const [destinationSpaceKey, setDestinationSpaceKey] = (0, $42omo.useState)(spaceKey);
    const [title, setTitle] = (0, $42omo.useState)(formatMessage($3e7e8a0093eea0b3$var$restoreContentModalMessaging[contentType].placeholderTitle, {
        date: selectedVersionDate
    }));
    const [restoreError, setRestoreError] = (0, $42omo.useState)(null);
    const [restoreIsActive, setRestoreIsActive] = (0, $42omo.useState)(false);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'restore-content-modal'
    });
    const { selectedSpaceClassification: selectedSpaceClassification, classificationError: classificationError } = (0, $50sHn.useClassificationChangeState)(String(contentId), destinationSpaceKey, spaceKey);
    const { hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const requiredSpaceOperations = [
        {
            targetType: 'page',
            operation: 'create'
        }
    ];
    const onSpaceSelectorChange = (selectedSpace)=>{
        const { spaceKey: selectedSpaceKey } = selectedSpace;
        setDestinationSpaceKey(selectedSpaceKey);
    };
    const { trackExperience: trackExperience } = (0, $aCrkK.useVersionHistoryExperienceTracking)();
    const [restoreVersion] = (0, $diswb.useMutation)((0, $eSUdr.default)`mutation RestoreContentModalRestoreContentMutation($spaceKey:String!$restoreVersionContentId:String!$title:String$type:String!){createContentContextual(input:{spaceKey:$spaceKey contentSpecificCreateInput:[{key:"restoreVersionContentId" value:$restoreVersionContentId}]status:CURRENT title:$title type:$type}){id links{context webui}}}`, {
        onCompleted: (data)=>{
            setRestoreIsActive(false);
            const contentUrl = `${data?.createContentContextual?.links?.context}${data?.createContentContextual?.links?.webui}?flow=restoreVersion`;
            trackExperience({
                contentType: contentType,
                experience: 'restoreExperience',
                task: 'start'
            });
            onRestore(selectedVersion);
            hideSidePanel();
            push(contentUrl);
        },
        onError: (graphqlError)=>{
            setRestoreIsActive(false);
            setRestoreError(graphqlError);
        }
    });
    const handleRestoreClick = (0, $42omo.useCallback)(()=>{
        setRestoreIsActive(true);
        setRestoreError(null);
        restoreVersion({
            variables: {
                spaceKey: destinationSpaceKey,
                title: title,
                type: contentType,
                restoreVersionContentId: selectedVersion.contentId
            }
        });
    }, [
        restoreVersion,
        destinationSpaceKey,
        title,
        contentType,
        selectedVersion
    ]);
    (0, $42omo.useEffect)(()=>{
        // succeed restore modal load experience on render
        trackExperience({
            contentType: contentType,
            experience: 'restoreModal',
            task: 'succeed'
        });
    }, [
        contentType,
        trackExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        testId: "restore-content-modal",
        width: "400px",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "medium",
        as: "h6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3e7e8a0093eea0b3$var$i18n.restoreContentTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3e7e8a0093eea0b3$var$ErrorSectionMessage, {
        error: restoreError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3e7e8a0093eea0b3$var$restoreContentModalMessaging[contentType].description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd5348f98ee50a88$export$68f60d0fda17fe94), {
        title: title,
        setTitle: setTitle,
        contentType: contentType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caYQd.SpaceSelector), {
        onChange: onSpaceSelectorChange,
        operationsUsedToDetermineRestrictedStatus: requiredSpaceOperations,
        showRestrictedSpaces: false,
        filterDefaultFromResults: false,
        spaceKey: destinationSpaceKey,
        labelTextTransform: "none",
        useMenuPortalTarget: true,
        spaceClassification: selectedSpaceClassification,
        hasClassificationError: !!classificationError,
        selectStyleOverrides: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 9999
                })
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: enforceStorageLimit(handleRestoreClick),
        isLoading: restoreIsActive,
        isDisabled: restoreIsActive,
        testId: "restore-content-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3e7e8a0093eea0b3$var$i18n.restoreButton))));
};
















var $1GzhS = parcelRequire("1GzhS");






var $4B2M3 = parcelRequire("4B2M3");





/* VersionHistoryItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
























var $2MuFw = parcelRequire("2MuFw");


var $3gadb = parcelRequire("3gadb");


var $56M4r = parcelRequire("56M4r");


var $5nBzc = parcelRequire("5nBzc");







const $073a675ae869dda9$var$i18n = (0, $cgtv4.defineMessages)({
    currentVersionDescription: {
        id: "version-history.current.version.description",
        defaultMessage: "Most recently saved"
    },
    copyIconLabel: {
        id: "version-history.copy.icon.label",
        defaultMessage: "Copy icon"
    },
    copyIconTooltip: {
        id: "version-history.copy.icon.tooltip",
        defaultMessage: "Copy all content"
    },
    copyIconTooltipCopied: {
        id: "version-history.copy.icon.tooltip-copied",
        defaultMessage: "Copied!"
    },
    lastEditedByLabel: {
        id: "version-history.author.last-edited-by.label",
        defaultMessage: "Last edited by {author}"
    },
    lastEditedByAnonymousUserLabel: {
        id: "version-history.author.last-edited-by-anonymous-user.label",
        defaultMessage: "Last edited by Anonymous"
    },
    lastEditedByDeactivatedUserLabel: {
        id: "version-history.author.last-edited-by-deactivated-user.label",
        defaultMessage: "Last edited by {author} (Deactivated)"
    },
    versionContainsAIContentTooltip: {
        id: "version-history.lozenge.version-contains-ai-content.tooltip",
        defaultMessage: "This version includes AI generated content"
    },
    aiContentText: {
        id: "version-history.lozenge.ai-content-text",
        defaultMessage: "AI Generated"
    }
});
const $073a675ae869dda9$var$styles = {
    customStylesContainer: "_1reo15vq _18m915vq _1bsbc4ae _1bto1l2s"
};
const $073a675ae869dda9$var$itemContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100'
});
const $073a675ae869dda9$export$15c96dc1a83defb4 = ({ handleVersionClick: handleVersionClick, isSelected: isSelected, title: title })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        isSelected: isSelected,
        testId: "version-history-item",
        onClick: ()=>handleVersionClick(null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: $073a675ae869dda9$var$itemContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "medium"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $073a675ae869dda9$var$i18n.currentVersionDescription)))));
};
const $073a675ae869dda9$export$e0ca0449ea662b5 = ({ version: version, handleVersionClick: handleVersionClick, isSelected: isSelected, isCopyAllowed: isCopyAllowed, handleCopyClick: handleCopyClick })=>{
    const { formatMessage: formatMessage, formatDate: formatDate, formatTime: formatTime } = (0, $8C5kA.default)();
    const versionContainsAIContentTooltip = formatMessage($073a675ae869dda9$var$i18n.versionContainsAIContentTooltip);
    const aiContentText = formatMessage($073a675ae869dda9$var$i18n.aiContentText);
    const copyAllContentText = formatMessage($073a675ae869dda9$var$i18n.copyIconTooltip);
    const copiedText = formatMessage($073a675ae869dda9$var$i18n.copyIconTooltipCopied);
    const [isCopyClicked, setIsCopyClicked] = (0, $42omo.useState)(false);
    const handleClick = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        handleCopyClick();
        setIsCopyClicked(true);
    }, [
        handleCopyClick
    ]);
    const handleMouseLeave = ()=>{
        setIsCopyClicked(false);
    };
    const displayName = ()=>{
        const author = version?.author;
        if (!author?.id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $073a675ae869dda9$var$i18n.lastEditedByAnonymousUserLabel);
        if (author?.isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$073a675ae869dda9$var$i18n.lastEditedByLabel,
            values: {
                author: author?.displayName
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$073a675ae869dda9$var$i18n.lastEditedByDeactivatedUserLabel,
            values: {
                author: author?.displayName
            }
        });
    };
    const shouldShowCopyIcon = isSelected && isCopyAllowed;
    const versionContainsAIContent = version.contentProperties?.latest?.versionContainsAIContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        isSelected: isSelected,
        testId: "version-history-item",
        onClick: ()=>handleVersionClick(version)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: $073a675ae869dda9$var$itemContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.050"
    }, (0, $9wGTI.fg)('whiteboard-show-ai-contributor-version-history') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $073a675ae869dda9$var$styles.customStylesContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "medium"
    }, (0, $ck0S9.getFormattedDate)(version.updatedTime, formatDate, formatTime))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: versionContainsAIContentTooltip
    }, versionContainsAIContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        maxWidth: 95,
        appearance: "default"
    }, aiContentText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "medium"
    }, (0, $ck0S9.getFormattedDate)(version.updatedTime, formatDate, formatTime), ' '), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle"
    }, displayName())), shouldShowCopyIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: isCopyClicked ? copiedText : copyAllContentText,
        position: "bottom" // force remount otherwise content is off-center
        ,
        key: isCopyClicked ? 'copied' : 'default'
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            ...tooltipProps,
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
            label: formatMessage($073a675ae869dda9$var$i18n.copyIconLabel),
            onClick: handleClick,
            onMouseLeave: handleMouseLeave,
            onBlur: handleMouseLeave,
            testId: "version-content-copy-button"
        }))));
};











var $abC4X = parcelRequire("abC4X");












var $610f86bf4169ee6c$exports = {};
$610f86bf4169ee6c$exports = new URL("GenericErrorImage.b96ea332.svg", import.meta.url).toString();


const $ed56899ddf7b83e5$var$i18n = (0, $cgtv4.defineMessages)({
    errorStateHeaderTitle: {
        id: "version-history.error-state.header.title",
        defaultMessage: "Unable to load"
    },
    retryOrRefreshText: {
        id: "version-history.error-state.retry.or.refresh.text",
        defaultMessage: "We were unable to load board history. Try again, or check your network connection."
    },
    newRetryOrRefreshText: {
        id: "version-history.error-state.new.retry.or.refresh.text",
        defaultMessage: "We were unable to load history. Try again, or check your network connection."
    },
    retryButtonText: {
        id: "version-history.error-state.retry.button.text",
        defaultMessage: "Retry"
    }
});
const $ed56899ddf7b83e5$var$errorStateContainerStyles = (0, $ecnYn.xcss)({
    flexGrow: 1
});
const $ed56899ddf7b83e5$export$c1ed4f415b9e7023 = ({ refetch: refetch })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleRefetch = (0, $42omo.useCallback)(()=>{
        refetch();
    }, [
        refetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ed56899ddf7b83e5$var$errorStateContainerStyles,
        paddingInline: "space.600",
        paddingBlockEnd: "space.600",
        testId: "version-error-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abC4X.default), {
        header: formatMessage($ed56899ddf7b83e5$var$i18n.errorStateHeaderTitle),
        description: (0, $9wGTI.fg)('confluence_frontend_databases_version_history_ui') ? formatMessage($ed56899ddf7b83e5$var$i18n.newRetryOrRefreshText) : formatMessage($ed56899ddf7b83e5$var$i18n.retryOrRefreshText),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: handleRefetch
        }, formatMessage($ed56899ddf7b83e5$var$i18n.retryButtonText)),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($610f86bf4169ee6c$exports)))
    }));
};


const $3210ac4b9f221c74$var$i18n = (0, $cgtv4.defineMessages)({
    currentVersionTitle: {
        id: "version-history.current.version.title",
        defaultMessage: "Current version"
    },
    autoSavedVersionsTitle: {
        id: "version-history.auto-saved.version.title",
        defaultMessage: "Autosaved versions"
    },
    historyAvailabilityInfo: {
        id: "version-history.history.availability.info",
        defaultMessage: "Whiteboards history is available for the past 30 days."
    },
    databasehHistoryAvailabilityInfo: {
        id: "version-history.database.history.availability.info",
        defaultMessage: "Databases history is available for the past 30 days."
    }
});
const $3210ac4b9f221c74$var$contentTypeMessaging = {
    whiteboard: $3210ac4b9f221c74$var$i18n.historyAvailabilityInfo,
    database: $3210ac4b9f221c74$var$i18n.databasehHistoryAvailabilityInfo
};
const $3210ac4b9f221c74$var$bodyContentWrapperStyles = (0, $ecnYn.xcss)({
    overflowY: 'auto',
    flexGrow: 1
});
const $3210ac4b9f221c74$var$SectionTitle = ({ title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.100",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), title)));
const $3210ac4b9f221c74$export$23bb3757bf428071 = ({ error: error, autosavedVersions: autosavedVersions, hasNextPage: hasNextPage, loadMoreVersions: loadMoreVersions, cursor: cursor, refetch: refetch, loading: loading, handleVersionClick: handleVersionClick, selectedVersion: selectedVersion, eventService: eventService, contentType: contentType, title: title })=>{
    const { onCopyVersionContent: onCopyVersionContent } = (0, $bac38a4aff776821$export$8fea35734ad69528)();
    // certain browsers may not allow copying
    // only whiteboards support copying content
    const isCopyAllowed = contentType === 'whiteboard' && eventService.hasEventHandler('copy');
    const handleCopyClick = (0, $42omo.useCallback)(()=>{
        eventService.triggerEvent('copy');
        if (selectedVersion) onCopyVersionContent(selectedVersion);
    }, [
        eventService,
        selectedVersion,
        onCopyVersionContent
    ]);
    if (error && !loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ed56899ddf7b83e5$export$c1ed4f415b9e7023), {
        refetch: refetch
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3210ac4b9f221c74$var$bodyContentWrapperStyles,
        "data-testId": "version-history-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3210ac4b9f221c74$var$SectionTitle, {
        title: $3210ac4b9f221c74$var$i18n.currentVersionTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $073a675ae869dda9$export$15c96dc1a83defb4), {
        handleVersionClick: handleVersionClick,
        isSelected: !selectedVersion,
        title: title
    })), autosavedVersions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3210ac4b9f221c74$var$SectionTitle, {
        title: $3210ac4b9f221c74$var$i18n.autoSavedVersionsTitle
    }), autosavedVersions.map((version)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $073a675ae869dda9$export$e0ca0449ea662b5), {
            version: version,
            key: version.number,
            handleVersionClick: handleVersionClick,
            isSelected: version.number === selectedVersion?.number,
            isCopyAllowed: isCopyAllowed,
            handleCopyClick: handleCopyClick
        });
    }), hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4B2M3.ObservableSpinner), {
        cursor: cursor,
        testId: "version-history-loading-spinner",
        onScrollTo: loadMoreVersions,
        observerOptions: {
            root: null,
            rootMargin: '0px',
            threshold: 0.05
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.200",
        paddingInlineEnd: "space.200",
        paddingInlineStart: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        align: "center",
        as: "p",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3210ac4b9f221c74$var$contentTypeMessaging[contentType]))));
};




























const $6f3a2c1a9f6e5048$var$bodyWrapperStyles = (0, $ecnYn.xcss)({
    flexGrow: '1'
});
const $6f3a2c1a9f6e5048$export$b32ca013fcba8075 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150",
            xcss: $6f3a2c1a9f6e5048$var$bodyWrapperStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.100",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150",
        xcss: $6f3a2c1a9f6e5048$var$bodyWrapperStyles
    }, children);
};


var $4WZFP = parcelRequire("4WZFP");

const $7a46560dab52d7e2$var$titleSkeleton = (0, $ecnYn.xcss)({
    height: '16px',
    width: '100%',
    borderRadius: 'radius.full'
});
const $7a46560dab52d7e2$var$subHeaderSkeletion = (0, $ecnYn.xcss)({
    height: '14px',
    borderRadius: 'radius.full',
    width: '60px',
    marginBottom: 'space.150'
});
const $7a46560dab52d7e2$var$versionItemSkeleton = (0, $ecnYn.xcss)({
    width: '75%',
    borderRadius: 'radius.full'
});
const $7a46560dab52d7e2$var$sectionBodySkeleton = (0, $ecnYn.xcss)({
    width: '100%',
    paddingBlock: 'space.250'
});
const $7a46560dab52d7e2$export$ad13dd24f966ba14 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        "data-testId": "version-history-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WZFP.SidePanelHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $7a46560dab52d7e2$var$titleSkeleton,
        backgroundColor: "color.skeleton"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f3a2c1a9f6e5048$export$b32ca013fcba8075), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $7a46560dab52d7e2$var$sectionBodySkeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $7a46560dab52d7e2$var$subHeaderSkeletion,
        paddingBlock: "space.100",
        paddingInline: "space.200",
        backgroundColor: "color.skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $7a46560dab52d7e2$var$versionItemSkeleton,
        paddingBlock: "space.100",
        backgroundColor: "color.skeleton"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $7a46560dab52d7e2$var$sectionBodySkeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $7a46560dab52d7e2$var$subHeaderSkeletion,
        paddingBlock: "space.100",
        paddingInline: "space.200",
        backgroundColor: "color.skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $7a46560dab52d7e2$var$versionItemSkeleton,
        paddingBlock: "space.100",
        paddingInline: "space.200",
        backgroundColor: "color.skeleton"
    }))));
};


const $641b32b3bb33877e$var$headerTitleStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});
const $641b32b3bb33877e$var$i18n = (0, $cgtv4.defineMessages)({
    versionHistoryTitle: {
        id: "version-history.title",
        defaultMessage: "History"
    },
    versionHistoryHeaderTitle: {
        id: "version-history.header-title",
        defaultMessage: "Version history"
    },
    versionHistoryIconLabel: {
        id: "version-history.icon.label",
        defaultMessage: "Frequent clock icon"
    },
    versionHistoryCloseButtonLabel: {
        id: "version-history.close.button.icon.label",
        defaultMessage: "Close button"
    },
    restoreWhiteboardLabel: {
        id: "version-history.restore.whiteboard.label",
        defaultMessage: "Restore as new whiteboard"
    },
    restoreWhiteboardButtonText: {
        id: "version-history.restore.whiteboard.button.text",
        defaultMessage: "Restore as new whiteboard"
    },
    restoreDatabaseButtonText: {
        id: "version-history.restore.database.button.text",
        defaultMessage: "Restore as new database"
    },
    restoreDatabaseLabel: {
        id: "version-history.restore.database.label",
        defaultMessage: "Restore as new database"
    }
});
const $641b32b3bb33877e$var$contentTypeMessaging = {
    whiteboard: {
        buttonText: $641b32b3bb33877e$var$i18n.restoreWhiteboardButtonText,
        label: $641b32b3bb33877e$var$i18n.restoreWhiteboardLabel
    },
    database: {
        buttonText: $641b32b3bb33877e$var$i18n.restoreDatabaseButtonText,
        label: $641b32b3bb33877e$var$i18n.restoreDatabaseLabel
    }
};
const $641b32b3bb33877e$var$VersionHistoryComponent = ({ contentId: contentId, title: title, headerHeight: headerHeight = 0, displayTopBorder: displayTopBorder, panelTop: panelTop = 0, eventService: eventService, setVersion: setVersion, contentType: contentType })=>{
    const { hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [showRestoreModal, setShowRestoreModal] = (0, $42omo.useState)(false);
    const { onVersionClick: onVersionClick, onVersionHistoryMenuOpen: onVersionHistoryMenuOpen, onRestoreModalClose: onRestoreModalClose } = (0, $bac38a4aff776821$export$8fea35734ad69528)();
    const { autosavedVersions: autosavedVersions, loading: loading, loadMoreVersions: loadMoreVersions, hasNextPage: hasNextPage, cursor: cursor, error: error, refetch: refetch } = (0, $f24fd770e6b9a487$export$c17d09885b37d368)({
        contentId: contentId,
        contentType: contentType
    });
    // current version is selected by default
    const [selectedVersion, setSelectedVersion] = (0, $42omo.useState)(null);
    const { trackExperience: trackExperience } = (0, $aCrkK.useVersionHistoryExperienceTracking)();
    const headerTitle = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? $641b32b3bb33877e$var$i18n.versionHistoryHeaderTitle : $641b32b3bb33877e$var$i18n.versionHistoryTitle;
    (0, $42omo.useEffect)(()=>{
        // succeed side panel experience on render
        trackExperience({
            contentType: contentType,
            experience: 'sidePanel',
            task: 'succeed'
        });
    }, [
        contentType,
        trackExperience
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!selectedVersion) setSelectedVersion(null);
    }, [
        setSelectedVersion,
        selectedVersion
    ]);
    (0, $42omo.useEffect)(()=>{
        onVersionHistoryMenuOpen();
    }, [
        onVersionHistoryMenuOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            setVersion(null);
        };
    }, [
        setVersion
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        onRestoreModalClose();
        setShowRestoreModal(false);
    }, [
        onRestoreModalClose
    ]);
    const handleVersionClick = (0, $42omo.useCallback)((version)=>{
        setSelectedVersion(version);
        onVersionClick(version);
        setVersion(version || null);
    }, [
        onVersionClick,
        setVersion
    ]);
    // current version does not return externalVersionId
    const isRestoreButtonDisabled = !!error || !Boolean(selectedVersion?.contentProperties?.latest?.externalVersionId);
    const handleRestoreVersionClick = (0, $42omo.useCallback)(()=>{
        trackExperience({
            contentType: contentType,
            experience: 'restoreModal',
            task: 'start'
        });
        setShowRestoreModal(true);
    }, [
        contentType,
        trackExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kmWRd.SidePanel), {
        headerHeight: headerHeight,
        displayTopBorder: displayTopBorder,
        panelTop: panelTop
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7a46560dab52d7e2$export$ad13dd24f966ba14), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        backgroundColor: "elevation.surface",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150",
        paddingBlock: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        xcss: $641b32b3bb33877e$var$headerTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
        label: formatMessage($641b32b3bb33877e$var$i18n.versionHistoryIconLabel),
        color: "var(--ds-icon, #292A2E)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "small",
        as: "h5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), headerTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        onClick: hideSidePanel,
        label: formatMessage($641b32b3bb33877e$var$i18n.versionHistoryCloseButtonLabel)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3210ac4b9f221c74$export$23bb3757bf428071), {
        autosavedVersions: autosavedVersions,
        hasNextPage: hasNextPage,
        loadMoreVersions: loadMoreVersions,
        cursor: cursor,
        error: error,
        refetch: refetch,
        loading: loading,
        handleVersionClick: handleVersionClick,
        selectedVersion: selectedVersion,
        eventService: eventService,
        contentType: contentType,
        title: title
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $50364c7681d2ff9d$export$87589ca4d6050188), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        "aria-label": formatMessage($641b32b3bb33877e$var$contentTypeMessaging[contentType].label),
        shouldFitContainer: true,
        onClick: handleRestoreVersionClick,
        isDisabled: isRestoreButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $641b32b3bb33877e$var$contentTypeMessaging[contentType].buttonText))))), showRestoreModal && selectedVersion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3e7e8a0093eea0b3$export$63ec0fdbb660e929), {
        onClose: handleClose,
        selectedVersion: selectedVersion,
        contentType: contentType
    }));
};
const $641b32b3bb33877e$export$bc676b00e8f62584 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
})($641b32b3bb33877e$var$VersionHistoryComponent);
module.exports["VersionHistory"] = $641b32b3bb33877e$export$bc676b00e8f62584;

});

parcelRegister("ck0S9", function(module, exports) {
const $a0d25f7e92df57be$export$92521769c5df59ad = (dateInputString, formatDate, formatTime)=>{
    const dateString = new Date(dateInputString);
    const formattedDate = formatDate(dateString, {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
    const formattedTime = formatTime(dateString, {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    });
    return `${formattedDate} ${formattedTime.replace('AM', 'a.m.').replace('PM', 'p.m.')}`;
};
module.exports["getFormattedDate"] = $a0d25f7e92df57be$export$92521769c5df59ad;

});

parcelRegister("lUzNY", function(module, exports) {

var $ajKhM = parcelRequire("ajKhM");

const $abbf907a8bf3bb4c$export$86e1b013192cc9f6 = new (0, $ajKhM.ContentTypesActionsService)();
module.exports["contentMoreActionsService"] = $abbf907a8bf3bb4c$export$86e1b013192cc9f6;

});

parcelRegister("3r60T", function(module, exports) {
class $1f097128e34aca92$export$8bb2aafdd7e4ca0b {
    dispose() {
        this.changeObjectSidebarShownHandler = [];
        this.changeObjectSidebarShownHandler_LEGACY = [];
    }
    registerChangeObjectSidebarShownHandler(callback) {
        this.changeObjectSidebarShownHandler.push(callback);
    }
    registerChangeObjectSidebarShownHandler_LEGACY(callback) {
        this.changeObjectSidebarShownHandler_LEGACY.push(callback);
    }
    onChangeObjectSidebarShown(state) {
        this.changeObjectSidebarShownHandler.forEach((callback)=>callback(state));
    }
    onChangeObjectSidebarShown_LEGACY(isShown) {
        this.changeObjectSidebarShownHandler_LEGACY.forEach((callback)=>callback(isShown));
    }
    constructor(){
        this.changeObjectSidebarShownHandler = void 0;
        this.changeObjectSidebarShownHandler_LEGACY = void 0;
        this.changeObjectSidebarShownHandler = [];
        this.changeObjectSidebarShownHandler_LEGACY = [];
    }
}
module.exports["ContentTypesObjectSidebarService"] = $1f097128e34aca92$export$8bb2aafdd7e4ca0b;

});

parcelRegister("exahZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5fMeR = parcelRequire("5fMeR");


var $6KwrO = parcelRequire("6KwrO");


var $3mVfX = parcelRequire("3mVfX");


var $6hmtW = parcelRequire("6hmtW");


var $9FoVw = parcelRequire("9FoVw");


var $f5Wgm = parcelRequire("f5Wgm");


var $9wGTI = parcelRequire("9wGTI");

const $f159370a32aca251$export$9008442889802bb3 = ()=>{
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel, hideCommentsPanel: hideCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCurrentView: setCurrentView } = (0, $3mVfX.useCommentsPanelActions)();
    const { currentView: currentView } = (0, $3mVfX.useCommentsPanelState)();
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const setCommentThreadHandler = (0, $42omo.useCallback)((threadId)=>{
        // highlight a comment in sidebar
        // if threadId is undefined, it means we are de-selecting
        setCurrentlySelectedThreadKey(threadId);
        if (threadId) {
            if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) {
                // Use unified navigation when feature gate is enabled
                // content-types-bridge-comments only has inline comments
                let expectedView = undefined;
                if (currentView === (0, $3mVfX.ViewValues).RESOLVED) {
                    expectedView = (0, $3mVfX.ViewValues).OPEN;
                    setCurrentView && setCurrentView((0, $3mVfX.ViewValues).OPEN);
                }
                (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                    scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                    context: (0, $9FoVw.NavigationContext).PANEL,
                    block: 'center',
                    annotationId: threadId,
                    commentType: (0, $f5Wgm.CommentType).INLINE,
                    annotationClicked: true,
                    expectedView: expectedView
                });
            } else // scroll to the comment thread in the sidebar
            scrollCommentsPanelToThread({
                annotationId: threadId,
                annotationClicked: true
            });
        }
    }, [
        setCurrentlySelectedThreadKey,
        scrollCommentsPanelToThread,
        currentView,
        setCurrentView
    ]);
    const showPanelHandler = (0, $42omo.useCallback)((threadId)=>{
        if (!isCommentsPanelShown) showCommentsPanel();
        if (threadId) setCommentThreadHandler(threadId);
    }, [
        isCommentsPanelShown,
        showCommentsPanel,
        setCommentThreadHandler
    ]);
    const hidePanelHandler = (0, $42omo.useCallback)(()=>{
        if (isCommentsPanelShown) hideCommentsPanel();
    }, [
        isCommentsPanelShown,
        hideCommentsPanel
    ]);
    (0, $42omo.useEffect)(()=>{
        commentService.registerSelectCommentThreadHandler(setCommentThreadHandler);
        commentService.registerShowPanelHandler(showPanelHandler);
        commentService.registerHidePanelHandler(hidePanelHandler);
        return ()=>{
            // un-set the handlers on component unmount
            commentService.registerSelectCommentThreadHandler(undefined);
            commentService.registerShowPanelHandler(undefined);
            commentService.registerHidePanelHandler(undefined);
        };
    }, [
        commentService,
        showPanelHandler,
        hidePanelHandler,
        setCommentThreadHandler
    ]);
};
module.exports["useRegisterCommentsPanelCallbacks"] = $f159370a32aca251$export$9008442889802bb3;

});

parcelRegister("ckYtV", function(module, exports) {

var $ajKhM = parcelRequire("ajKhM");

const $98c75de9c6816705$export$b14be44a1e8054b7 = new (0, $ajKhM.ContentTypesActionsService)();
module.exports["contentMainActionsService"] = $98c75de9c6816705$export$b14be44a1e8054b7;

});

parcelRegister("hzClJ", function(module, exports) {

var $ajKhM = parcelRequire("ajKhM");

const $45deabb561664896$export$3cfba92d89128616 = new (0, $ajKhM.ContentTypesActionsService)();
module.exports["contentCollaboratorsService"] = $45deabb561664896$export$3cfba92d89128616;

});

parcelRegister("j96gu", function(module, exports) {

var $ajKhM = parcelRequire("ajKhM");

const $a9fb895ec6d62898$export$f5a70a5466fbb969 = new (0, $ajKhM.ContentTypesActionsService)();
module.exports["contentBoardStatusService"] = $a9fb895ec6d62898$export$f5a70a5466fbb969;

});

parcelRegister("6attE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $bQm3c = parcelRequire("bQm3c");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $6S5EB = parcelRequire("6S5EB");


var $6fil2 = parcelRequire("6fil2");


var $7mpOv = parcelRequire("7mpOv");


var $9ILXP = parcelRequire("9ILXP");


var $lQS7C = parcelRequire("lQS7C");

// src/canvas/board/types.ts
var $3e4bbb1067fb0f7b$export$1739c82bfccbe497 = "canvas", $3e4bbb1067fb0f7b$export$94992737b5e17ca5 = "board";



var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/canvas/board/manifest.ts
var $e68d13d0dea15257$var$canvasBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $3e4bbb1067fb0f7b$export$1739c82bfccbe497),
    resourceType: (0, $3e4bbb1067fb0f7b$export$94992737b5e17ca5),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/canvas/board/index.ts
var $e68d13d0dea15257$export$4207164a16ce22a0 = class _CanvasBoardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e68d13d0dea15257$var$canvasBoardAriStaticOpts.qualifier,
            platformQualifier: $e68d13d0dea15257$var$canvasBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e68d13d0dea15257$var$canvasBoardAriStaticOpts.resourceOwner,
            resourceType: $e68d13d0dea15257$var$canvasBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $e68d13d0dea15257$var$canvasBoardAriStaticOpts);
        return new _CanvasBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $e68d13d0dea15257$var$canvasBoardAriStaticOpts);
        return new _CanvasBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
};


// src/canvas/database/types.ts
var $f3367767c9312991$export$21d39021bd86ec6f = "canvas", $f3367767c9312991$export$e7fab7e0dfc50566 = "database";








// src/canvas/database/manifest.ts
var $4b5f33a49ee1db18$var$canvasDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $f3367767c9312991$export$21d39021bd86ec6f),
    resourceType: (0, $f3367767c9312991$export$e7fab7e0dfc50566),
    resourceIdSlug: "{databaseId}",
    resourceIdSegmentFormats: {
        databaseId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/canvas/database/index.ts
var $4b5f33a49ee1db18$export$b5af0e69d7a83a9e = class _CanvasDatabaseAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4b5f33a49ee1db18$var$canvasDatabaseAriStaticOpts.qualifier,
            platformQualifier: $4b5f33a49ee1db18$var$canvasDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4b5f33a49ee1db18$var$canvasDatabaseAriStaticOpts.resourceOwner,
            resourceType: $4b5f33a49ee1db18$var$canvasDatabaseAriStaticOpts.resourceType,
            resourceId: `${opts.databaseId}`,
            resourceIdSegmentValues: {
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $4b5f33a49ee1db18$var$canvasDatabaseAriStaticOpts);
        return new _CanvasDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $4b5f33a49ee1db18$var$canvasDatabaseAriStaticOpts);
        return new _CanvasDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};



var $hp2SH = parcelRequire("hp2SH");


var $1AV5C = parcelRequire("1AV5C");

/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $68bcf5e0dd294dcb$export$7af3c7e5c4c08291 = (0, $eSUdr.default)`query WhiteboardTokenQuery($contentId:ID!){canvasToken(contentId:$contentId){token}contentMediaSession(contentId:$contentId){accessTokens{readOnlyToken{value}readWriteToken{value}}configuration{fileStoreUrl}}entitlements{whiteboardFeatures{smartConnectors{isEntitled}smartSections{isEntitled}}}}`;





const $69a092ebfa4d47df$export$435620ef3a755b60 = (0, $eSUdr.default)`query ExternalWhiteboardTokenQuery($shareToken:String!){externalCanvasToken(shareToken:$shareToken){token}externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value}readWriteToken{value}}configuration{fileStoreUrl}}entitlements{whiteboardFeatures{smartConnectors{isEntitled}smartSections{isEntitled}}}}`;


const $836053ad975c4b64$var$emptyContext = ()=>({
        spaceId: '',
        tenantId: '',
        contentId: '',
        confluenceEdition: '',
        isExternal: false,
        shareToken: '',
        dataSecurityPolicyPageExport: null,
        isAIEnabledForContent: false,
        isRovoEnabledForContent: false
    });
/**
 * Used to refer to the 'home' view.
 */ const $836053ad975c4b64$var$FALLBACK_HOME_KEY = 'root';
/**
 * Used to refer to the 'create' view.
 */ const $836053ad975c4b64$var$FALLBACK_CREATE_KEY = 'create';
/**
 * Set to a value a little below the server timeout to account for networking delays and retries.
 */ const $836053ad975c4b64$var$EXPIRY_TIME_MILLSECONDS = 540000;
/**
 * Note: This is currently a module scope value as we recreate the token service on SPA transitions. This would cause us to fetch cached tokens on the first transition to a board which would result in a token expiry errors.
 * @see {@link https://atlassian.slack.com/archives/C027MLUFSFN/p1717038827909519?thread_ts=1716372417.294799&cid=C027MLUFSFN}
 */ let $836053ad975c4b64$var$isFirstLoad = true;
const $836053ad975c4b64$var$allowedDocumentTypes = [
    'whiteboard',
    'database'
];
class $836053ad975c4b64$export$b957651e6c38f607 {
    dispose() {
        this.handlers = [];
        this.context = $836053ad975c4b64$var$emptyContext();
        this.token = undefined;
        this.cache = new Map();
    }
    /**
   * Sets the context of the token service.
   * @description Used to fetch tokens pinned to space & site.
   */ setContext({ spaceId: spaceId, tenantId: tenantId, contentId: contentId, confluenceEdition: confluenceEdition, isExternal: isExternal, shareToken: shareToken, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent }) {
        this.context.spaceId = spaceId;
        this.context.tenantId = tenantId;
        this.context.contentId = contentId;
        this.context.confluenceEdition = confluenceEdition;
        this.context.isExternal = isExternal;
        this.context.shareToken = shareToken;
        this.context.dataSecurityPolicyPageExport = dataSecurityPolicyPageExport;
        this.context.isAIEnabledForContent = isAIEnabledForContent;
        this.context.isRovoEnabledForContent = isRovoEnabledForContent;
    }
    /**
   * @description Method for taking an encoded access token and determining whether or
   * not it has read permissions for the document
   * @returns boolean value indicating whether the provided token has sufficient
   * document permissions or not
   */ isValidToken(token, key) {
        if (token?.accessToken) {
            /**
       * If on home or create routes, existence of a token is enough to ensure
       * the user has permission to take the provided action (view home or create).
       */ if (key === $836053ad975c4b64$var$FALLBACK_HOME_KEY) return true;
            if (key === $836053ad975c4b64$var$FALLBACK_CREATE_KEY) return true;
            const decodedAccessToken = (0, $9ILXP.default)(token.accessToken);
            const documentARI = Object.keys(decodedAccessToken.access).find((ari)=>{
                return (0, $e68d13d0dea15257$export$4207164a16ce22a0).check(ari) || (0, $4b5f33a49ee1db18$export$b5af0e69d7a83a9e).check(ari);
            });
            if (documentARI) {
                const documentAccess = decodedAccessToken.access[documentARI];
                if (documentAccess && documentAccess.includes('read')) return true;
            }
        }
        return false;
    }
    /**
   * @description Method for taking an encoded access token and returning the permissions
   * @returns an empty array if no claims exist. An array with [read] for read only or [read, write] if editable
   */ getPermissions(token) {
        if (token?.accessToken) {
            const decodedAccessToken = (0, $9ILXP.default)(token.accessToken);
            const documentARI = Object.keys(decodedAccessToken.access).find((ari)=>{
                return (0, $e68d13d0dea15257$export$4207164a16ce22a0).check(ari) || (0, $4b5f33a49ee1db18$export$b5af0e69d7a83a9e).check(ari);
            });
            if (documentARI) return decodedAccessToken.access[documentARI];
        }
        return [];
    }
    /**
   * Loads a token by reaching out to a specific token URL.
   * @param referenceId
   */ async loadToken(referenceId) {
        // We cannot fetch a token without a context.
        // Hence, we default to 'empty'.
        if (!this.hasContext()) return undefined;
        const handleError = (err)=>{
            this.tokenErrorHandler(err);
            return undefined;
        };
        const { spaceId: spaceId, tenantId: tenantId, contentId: contentId, shareToken: shareToken, isExternal: isExternal, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = this.context;
        try {
            const tokenPromise = isExternal && shareToken ? await $836053ad975c4b64$var$fetchExternalTokenDataByGraphQL(shareToken) : await $836053ad975c4b64$var$fetchTokenDataByGraphQL(contentId, $836053ad975c4b64$var$isFirstLoad);
            $836053ad975c4b64$var$isFirstLoad = false;
            const { accessToken: accessToken, mediaToken: mediaToken, mediaBaseUrl: mediaBaseUrl, whiteboardEntitlements: whiteboardEntitlements } = tokenPromise;
            if (!accessToken || !mediaToken || !mediaBaseUrl) {
                const missingItems = [
                    ...!accessToken ? [
                        'accessToken'
                    ] : [],
                    ...!mediaToken ? [
                        'mediaToken'
                    ] : [],
                    ...!mediaBaseUrl ? [
                        'mediaBaseUrl'
                    ] : []
                ];
                const missingTokenError = new Error(`missing token data for: ${missingItems.join(', ')}`);
                return handleError(missingTokenError);
            }
            const containerAri = (0, $lQS7C.ConfluenceSpaceAri).create({
                siteId: tenantId,
                spaceId: spaceId
            });
            const boardAri = referenceId ? this.getBoardAri(referenceId, tenantId) : '';
            const features = {
                whiteboards: {
                    ...whiteboardEntitlements.whiteboards,
                    aiGenerate: {
                        isEntitled: isAIEnabledForContent
                    },
                    aiClustering: {
                        isEntitled: isAIEnabledForContent
                    },
                    aiTeammate: {
                        isEntitled: isAIEnabledForContent && isRovoEnabledForContent
                    },
                    aiSmartButton: {
                        isEntitled: isAIEnabledForContent && isRovoEnabledForContent
                    },
                    aiJiraSearch: {
                        isEntitled: isAIEnabledForContent
                    },
                    jiraIssueUnfurl: {
                        isEntitled: whiteboardEntitlements.whiteboards?.smartConnectors?.isEntitled ?? false
                    }
                }
            };
            const policies = dataSecurityPolicyPageExport != null ? {
                policies: {
                    dataSecurityPolicy: {
                        pageExport: dataSecurityPolicyPageExport
                    }
                }
            } : {};
            return {
                container: containerAri.toString(),
                board: boardAri.toString(),
                accessToken: accessToken,
                mediaToken: mediaToken,
                mediaBaseUrl: mediaBaseUrl,
                mediaCollectionId: contentId,
                features: features,
                edition: this.context.confluenceEdition,
                ...policies
            };
        } catch (err) {
            return handleError(err);
        }
    }
    /**
   * Checks if there is enough data in {@link context} to fetch a token.
   */ hasContext() {
        const hasTenantId = this.context.tenantId.length > 0;
        const hasSpaceId = this.context.spaceId.length > 0;
        const hasContentId = this.context.contentId.length > 0;
        const hasConfluenceEdition = Boolean(this.context.confluenceEdition);
        return hasTenantId && hasSpaceId && hasContentId && hasConfluenceEdition;
    }
    /**
   * Checks if the {@link token} has expected data in it.
   */ hasToken(token) {
        return Boolean(token && token.accessToken && token.container);
    }
    constructor(documentType){
        this.documentType = void 0;
        this.handlers = void 0;
        this.context = void 0;
        this.token = void 0;
        this.cache = void 0;
        this.invalidTokenHandler = void 0;
        // @ts-ignore
        this.tokenErrorHandler = void 0;
        /**
     * A method called on every route transition on whiteboards.
     * @returns <void> Sets a fresh token with encoded permissions.
     */ this.updateToken = async (referenceId)=>{
            const token = await this.preloadToken(referenceId);
            this.token = token;
            this.handlers.forEach((handler)=>handler(token));
        };
        /**
     * A method called on every route transition on whiteboards to empty the existing token.
     * @returns <void> Sets an empty token with encoded permissions.
     */ this.resetToken = ()=>{
            this.token = undefined;
            this.context = $836053ad975c4b64$var$emptyContext();
            this.handlers.forEach((handler)=>handler(undefined));
        };
        /**
     * Setup listeners for token changes.
     * @description Called everytime the token updates.
     */ this.onTokenChange = (cb)=>{
            this.handlers.push(cb);
        };
        /**
     * Setup listener for invalid token
     * @description Called within preloadToken if the token is lacking sufficient whiteboard permissions.
     */ this.onInvalidToken = (cb)=>{
            this.invalidTokenHandler = cb;
        };
        /**
     * Setup listener for a token error
     * @description Called within loadToken's catch in case there is an error loading the token
     */ // @ts-ignore
        this.onTokenLoadError = (cb)=>{
            this.tokenErrorHandler = cb;
        };
        /**
     * Checks if the error message indicates that token data is missing.
     * @description Used to determine if the experience should be aborted due to missing token data.
     * @returns boolean indicating whether the error message contains 'missing token data'.
     */ this.hasMissingTokenData = (message)=>{
            if (message.includes('missing token data')) // Missing accessToken, mediaToken, or mediaBaseUrl necessary for whiteboards to function
            return true;
            return false;
        };
        /**
     * Setup listeners for token initialisation.
     * @description Called once at the start of the lifetime of the whiteboard frame.
     */ this.onTokenInit = (cb)=>{
            cb(this.token);
        };
        this.getHashKey = (id)=>{
            return (0, $1AV5C.hashData)(JSON.stringify({
                id: id,
                ...this.context
            }));
        };
        /**
     * Starts preloading a token, and stores the result in {@link cache}.
     * @description Implements a mutex by keeping one promise per content id.
     */ this.preloadToken = (id)=>{
            const key = id ? this.getHashKey(id) : $836053ad975c4b64$var$FALLBACK_HOME_KEY;
            const entry = this.cache.get(key);
            const now = Date.now();
            const fetching = entry?.promise;
            const resolved = entry?.resolved;
            const expired = Boolean(entry?.expiresAt && now >= entry.expiresAt);
            if (fetching) {
                if (!resolved) return fetching;
                if (!expired) return fetching;
                else this.cache.delete(key);
            }
            const promise = this.loadToken(id);
            this.cache.set(key, {
                promise: promise,
                resolved: false
            });
            promise.then((token)=>{
                // Do not hold onto empty tokens
                if (!this.hasToken(token)) {
                    this.cache.delete(key);
                    return;
                }
                if (!this.isValidToken(token, key)) {
                    this.cache.delete(key);
                    this.invalidTokenHandler();
                    return;
                }
                this.cache.set(key, {
                    promise: promise,
                    resolved: true,
                    expiresAt: now + $836053ad975c4b64$var$EXPIRY_TIME_MILLSECONDS
                });
            }).catch((_err)=>{
                // Do not hold onto tokens which failed to be fetched
                this.cache.delete(key);
            });
            return promise;
        };
        /**
     * Gives the consumer the existing token for a route, or starts fetching one.
     * @description Uses the same mutex implemented in {@link preloadToken}
     */ this.getToken = (id)=>{
            return this.preloadToken(id);
        };
        /**
     * A method for forcing refresh of a token.
     * @description Used when permissions change on a whiteboard, forcing users
     * to refetch a new token.
     * @description Delegates to {@link revokeToken} to revoke the current token.
     * @returns <void>
     */ this.refreshToken = async (id)=>{
            this.revokeToken(id);
            await this.updateToken(id);
        };
        /**
     * A method for revoking a token.
     * @description Used when permissions change on a whiteboard, forcing users
     * to refetch a new token.
     * @returns <void>
     */ this.revokeToken = (id)=>{
            const key = id ? this.getHashKey(id) : $836053ad975c4b64$var$FALLBACK_HOME_KEY;
            this.token = undefined;
            this.cache.delete(key);
            this.handlers.forEach((handler)=>handler(undefined));
        };
        /**
     * A method for getting the board ari.
     * @description Used to determine the board ari for a given reference id and document type.
     * @param referenceId
     * @param tenantId
     * @private
     */ this.getBoardAri = (referenceId, tenantId)=>{
            return this.documentType == 'whiteboard' ? (0, $e68d13d0dea15257$export$4207164a16ce22a0).create({
                siteId: tenantId,
                boardId: referenceId
            }) : (0, $4b5f33a49ee1db18$export$b5af0e69d7a83a9e).create({
                siteId: tenantId,
                databaseId: referenceId
            });
        };
        this.documentType = documentType;
        this.handlers = [];
        this.context = $836053ad975c4b64$var$emptyContext();
        this.token = undefined;
        this.cache = new Map();
        this.invalidTokenHandler = ()=>{};
        this.tokenErrorHandler = ()=>{};
    }
}
const $836053ad975c4b64$var$fetchTokenDataByGraphQL = async (contentId, useCache = false)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const tokenQuery = await (0, $hp2SH.getApolloClient)().query({
        query: (0, $68bcf5e0dd294dcb$export$7af3c7e5c4c08291),
        variables: {
            contentId: contentId
        },
        context: {
            fetchOptions: {
                ignoreNoNetworkError: true
            }
        },
        fetchPolicy: useCache ? 'cache-first' : 'no-cache'
    });
    const accessToken = tokenQuery?.data?.canvasToken?.token;
    const readOnlyMediaToken = tokenQuery?.data?.contentMediaSession?.accessTokens?.readOnlyToken?.value;
    const readWriteMediaToken = tokenQuery?.data?.contentMediaSession?.accessTokens?.readWriteToken?.value;
    const mediaBaseUrl = tokenQuery?.data?.contentMediaSession?.configuration?.fileStoreUrl;
    const whiteboardEntitlements = tokenQuery?.data?.entitlements?.whiteboardFeatures;
    return {
        accessToken: accessToken,
        mediaToken: readWriteMediaToken || readOnlyMediaToken,
        mediaBaseUrl: mediaBaseUrl,
        whiteboardEntitlements: {
            whiteboards: whiteboardEntitlements
        }
    };
};
const $836053ad975c4b64$var$fetchExternalTokenDataByGraphQL = async (shareToken)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const tokenQuery = await (0, $hp2SH.getApolloClient)().query({
        query: (0, $69a092ebfa4d47df$export$435620ef3a755b60),
        variables: {
            shareToken: shareToken
        },
        context: {
            allowOnExternalPage: true,
            fetchOptions: {
                ignoreNoNetworkError: true
            }
        },
        fetchPolicy: 'no-cache'
    });
    const data = tokenQuery?.data;
    const accessToken = data?.externalCanvasToken?.token;
    const readOnlyMediaToken = data?.externalContentMediaSession?.accessTokens?.readOnlyToken?.value;
    const readWriteMediaToken = data?.externalContentMediaSession?.accessTokens?.readWriteToken?.value;
    const mediaBaseUrl = tokenQuery?.data?.externalContentMediaSession?.configuration?.fileStoreUrl;
    const whiteboardEntitlements = data?.entitlements?.whiteboardFeatures;
    return {
        accessToken: accessToken,
        mediaToken: readWriteMediaToken || readOnlyMediaToken,
        mediaBaseUrl: mediaBaseUrl,
        whiteboardEntitlements: {
            whiteboards: whiteboardEntitlements
        }
    };
};


const $98eb6766d8546971$export$403c2a860d415c5b = ({ tenantId: tenantId, space: space, referenceId: referenceId, contentId: contentId, shareToken: shareToken, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, refetch: refetch, documentType: documentType = 'whiteboard', onPermissionChange: onPermissionChange })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const [tokenService] = (0, $42omo.useState)(()=>new (0, $836053ad975c4b64$export$b957651e6c38f607)(documentType));
    const isExternal = (0, $6S5EB.isExternalShareRequest)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    (0, $42omo.useEffect)(()=>{
        tokenService.onInvalidToken(()=>{
            refetch?.();
        });
        tokenService.onTokenChange((token)=>{
            if (onPermissionChange) {
                const permissions = tokenService.getPermissions(token);
                onPermissionChange(permissions);
            }
        });
        tokenService.onTokenLoadError((error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) refetch?.();
            else if ((0, $6fil2.containsNetworkError)(error)) experienceTracker.abort({
                name: (0, $irVI7.WHITEBOARD_EXPERIENCE),
                reason: 'Network error while fetching token'
            });
            else if ((0, $f9jv7.isNotFoundError)(error)) experienceTracker.abort({
                name: (0, $irVI7.WHITEBOARD_EXPERIENCE),
                reason: 'Requested content not found while fetching token'
            });
            else if (tokenService.hasMissingTokenData(error.message)) experienceTracker.abort({
                name: (0, $irVI7.WHITEBOARD_EXPERIENCE),
                reason: 'Missing token data while fetching token'
            });
            else experienceTracker.fail({
                name: (0, $irVI7.WHITEBOARD_EXPERIENCE),
                error: error
            });
        });
    }, [
        tokenService,
        refetch,
        experienceTracker,
        onPermissionChange
    ]);
    // Update the current token whenever the space or contentId changes
    (0, $42omo.useEffect)(()=>{
        if (!space.id) return;
        tokenService.setContext({
            spaceId: space.id,
            tenantId: tenantId,
            contentId: contentId,
            confluenceEdition: edition || '',
            isExternal: isExternal,
            shareToken: shareToken,
            dataSecurityPolicyPageExport: dataSecurityPolicyPageExport,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
        // For databases, always fetch token (can use contentId when referenceId is missing)
        // For whiteboards, only fetch when referenceId is available
        if (referenceId || documentType === 'database') tokenService.updateToken(referenceId ?? undefined).catch(()=>{
        // handled by the `onTokenLoadError` function defined in the useEffect above this
        });
        return ()=>tokenService.resetToken();
    }, [
        tokenService,
        tenantId,
        space.id,
        referenceId,
        contentId,
        edition,
        shareToken,
        isExternal,
        dataSecurityPolicyPageExport,
        isAIEnabledForContent,
        isRovoEnabledForContent,
        documentType
    ]);
    return tokenService;
};
module.exports["useTokenService"] = $98eb6766d8546971$export$403c2a860d415c5b;

});

parcelRegister("5wU3V", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j6S25 = parcelRequire("j6S25");

var $cOrQJ = parcelRequire("cOrQJ");


var $cMmuo = parcelRequire("cMmuo");


var $7J5Uc = parcelRequire("7J5Uc");

class $dc00d7996d97ffde$export$9c1453fd5233c0aa {
    dispose() {
        this.handlers.clear();
    }
    updateTheme(theme) {
        this.theme = theme;
        this.handlers.forEach((handler)=>handler(theme));
    }
    onThemeChange(cb) {
        this.handlers.add(cb);
        return ()=>{
            this.handlers.delete(cb);
        };
    }
    getTheme() {
        return this.theme;
    }
    constructor(){
        this.handlers = new Set();
        this.theme = undefined;
    }
}
const $dc00d7996d97ffde$export$add900538e5d49b8 = new $dc00d7996d97ffde$export$9c1453fd5233c0aa();


const $3bf16ca42f9e188b$export$2bcebcd0d350d772 = ()=>{
    const appliedTheme = (0, $cOrQJ.default)();
    const [{ isInitialized: themingInitialized }] = (0, $7J5Uc.useThemingState)();
    const effectiveThemeSerialized = (0, $42omo.useMemo)(()=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        const theme = isSSR || !themingInitialized ? (0, $cMmuo.getSavedThemeLocal)() : appliedTheme;
        return theme ? (0, $j6S25.themeObjectToString)(theme) : undefined;
    }, [
        themingInitialized,
        appliedTheme
    ]);
    // Value should always reflect the originally calculated value
    const initialThemeSerialized = (0, $42omo.useRef)(effectiveThemeSerialized);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            (0, $dc00d7996d97ffde$export$add900538e5d49b8).dispose();
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (appliedTheme) (0, $dc00d7996d97ffde$export$add900538e5d49b8).updateTheme(appliedTheme);
    }, [
        appliedTheme
    ]);
    return {
        themingService: (0, $dc00d7996d97ffde$export$add900538e5d49b8),
        initialThemeSerialized: initialThemeSerialized.current
    };
};
module.exports["useThemingService"] = $3bf16ca42f9e188b$export$2bcebcd0d350d772;

});

parcelRegister("cMmuo", function(module, exports) {

var $fzfTC = parcelRequire("fzfTC");

const $d56176af0bdf2d09$export$db80de5fdc8ebf2b = (0, $fzfTC.ThemeAPI).getSavedThemeLocal;
module.exports["getSavedThemeLocal"] = $d56176af0bdf2d09$export$db80de5fdc8ebf2b;

});

parcelRegister("9Zj7l", function(module, exports) {

var $hysf6 = parcelRequire("hysf6");


var $aWwYt = parcelRequire("aWwYt");

const $b939c27ef0cabb4b$export$8a58354df2cc0213 = ()=>{
    const { showDetailsPanel: showDetailsPanel } = (0, $hysf6.useShowDetailsPanel)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const detailsPanelService = {
        showPanel: ()=>{
            showDetailsPanel();
        },
        hidePanel: ()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            hideObjectSidebar();
        }
    };
    return detailsPanelService;
};
module.exports["useDetailsPanelService"] = $b939c27ef0cabb4b$export$8a58354df2cc0213;

});

parcelRegister("8fSJ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $27fJD = parcelRequire("27fJD");


var $6JLuV = parcelRequire("6JLuV");


var $fD5Hh = parcelRequire("fD5Hh");

const $6397e3353d5131f3$export$4575850911ab1ca9 = (0, $fD5Hh.createCommand)('open-preview-panel');
const $6397e3353d5131f3$export$a1142d091bcf8405 = (0, $fD5Hh.createCommand)('is-preview-panel-available');


const $b73182d5fc0f2f86$export$ca5fcf68ef635b5c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { open: openPreviewPanel } = (0, $6JLuV.useOpenPreviewPanel)();
    const bindHandlersCallback = (0, $42omo.useCallback)((on)=>{
        // Handle OpenPreviewPanelCommand
        on((0, $6397e3353d5131f3$export$4575850911ab1ca9), (data)=>{
            const { url: url, ari: ari } = data;
            try {
                openPreviewPanel({
                    url: url,
                    ari: ari
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'opened',
                        actionSubject: 'previewPanel',
                        actionSubjectId: 'open',
                        source: 'whiteboards-afm-bridge',
                        attributes: {
                            ari: ari
                        }
                    }
                }).fire();
            } catch (error) {
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'previewPanel',
                        actionSubjectId: 'open',
                        source: 'whiteboards-afm-bridge',
                        attributes: {
                            reason: 'open_preview_panel_error',
                            ari: ari,
                            error: error instanceof Error ? error.message : 'unknown_error'
                        }
                    }
                }).fire();
            }
        });
        // Handle IsPreviewPanelAvailableCommand
        on((0, $6397e3353d5131f3$export$a1142d091bcf8405), (data)=>{
            const { ari: ari } = data;
            try {
                const available = (0, $27fJD.isPreviewPanelAvailable)({
                    ari: ari
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'checked',
                        actionSubject: 'previewPanel',
                        actionSubjectId: 'availability',
                        source: 'whiteboards-afm-bridge',
                        attributes: {
                            ari: ari,
                            isAvailable: available
                        }
                    }
                }).fire();
                return available;
            } catch (error) {
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'previewPanel',
                        actionSubjectId: 'checkAvailability',
                        source: 'whiteboards-afm-bridge',
                        attributes: {
                            reason: 'check_availability_error',
                            ari: ari,
                            error: error instanceof Error ? error.message : 'unknown_error'
                        }
                    }
                }).fire();
                return false;
            }
        });
    }, [
        createAnalyticsEvent,
        openPreviewPanel
    ]);
    return bindHandlersCallback;
};
module.exports["usePreviewPanelHandler"] = $b73182d5fc0f2f86$export$ca5fcf68ef635b5c;

});

parcelRegister("ajKhM", function(module, exports) {
class $c2d4c8ee0dd05cbe$export$abca6ba7b5fccda8 {
    dispose() {
        this.handlers.clear();
    }
    updateActions(data) {
        this.handlers.forEach((handler)=>handler(data));
    }
    onActionsUpdate(cb) {
        this.handlers.add(cb);
        return ()=>{
            this.handlers.delete(cb);
        };
    }
    constructor(){
        this.handlers = new Set();
    }
}
module.exports["ContentTypesActionsService"] = $c2d4c8ee0dd05cbe$export$abca6ba7b5fccda8;

});


//# sourceMappingURL=ExternalSharePage.dcaded4b.js.map
